<template>
    <div class="account">
        <div class="container">
            <div class="account__wrapper">
                <AccountSideMenu></AccountSideMenu>

                <div class="account__contain opinions">
                    <h5 class="account__section-title">Opinie:</h5>
                    <span class="opinions__text">Skontaktuj się z nami, aby przekazać opinię o serwisie czy poinformować o problemie technicznym.</span>

                    <!-- <div class="opinions__btns">
                        <button class="opinions__btn" :class="{'active': isForm}" @click="isForm = true">Skontaktuj się z serwisem</button>
                        <button class="opinions__btn" :class="{'active': !isForm}" @click="isForm = false">Wypełnij ankietę</button>
                    </div> -->

                    <div class="opinions__form contact">
                        <template v-if="isForm">
                            <form data-aos="fade-in" @submit.prevent="handleSubmit" v-if="!isSend">
                                <div class="columns is-multiline">
                                    <div class="column is-12-tablet is-6-desktop">    
                                        <div class="form-group form-group--text">
                                            <label class="contact__label">E-mail:</label>
                                            <div v-if="errors.email" class="errors">{{ errors.email }}</div>
                                            <input
                                                class="contact__input"
                                                type="text"
                                                maxlength="50"
                                                placeholder="wpisz twój e-mail"
                                                v-model="fields.email"
                                            />
                                        </div>
                                    </div>

                                    <div class="column is-12-tablet is-6-desktop">    
                                        <div class="form-group form-group--text">
                                            <label class="contact__label">Temat:</label>
                                            <div v-if="errors.subject" class="errors">{{ errors.subject }}</div>
                                            <input
                                                class="contact__input"
                                                type="text"
                                                maxlength="50"
                                                placeholder="wpisz temat wiadomości"
                                                v-model="fields.subject"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="columns">
                                    <div class="column is-12">
                                        <div class="form-group form-group--textarea">
                                            <label class="contact__label">Treść wiadomości:</label>
                                            <div v-if="errors.message" class="errors">{{ errors.message }}</div>
                                            <textarea
                                                class="contact__textarea"
                                                maxlength="4000"
                                                placeholder="..."
                                                v-model="fields.message"
                                            ></textarea>
                                        </div>

                                        <span class="contact__label">Wyrażam zgodę na przetwarzanie moich danych osobowych przez Telewizję Polską S. A. w likwidacji z siedzibą w Warszawie, przy ul. J.P. Woronicza 17 celem:</span>
                                        
                                        <div class="form-group form-group--checkbox">
                                            <input class="contact__checkbox" type="checkbox" id="agreement" name="agreement" v-model="fields.agreement">
                                            <label for="agreement" class="contact__label">* nawiązania kontaktu</label>
                                            <div v-if="errors.agreement" class="errors">{{ errors.agreement }}</div>
                                        </div>

                                        <!-- <span class="contact__label">Telewizja Polska S.A., jako administrator danych osobowych podanych w powyższym formularzu, informuje, iż:</span>
                                        
                                        <div class="contact__expand">
                                            <span class="contact__expand-btn" @click="isExpanded = !isExpanded" v-html="isExpanded ? 'Zwiń' : 'Rozwiń'"></span>
                                            <span class="contact__expanded contact__label" v-if="isExpanded" data-aos="fade-in">Lorem ipsum amet sit dolor</span>
                                        </div>

                                        <div class="form-group form-group--checkbox">
                                            <input class="contact__checkbox" type="checkbox" id="regulations" name="regulations" v-model="fields.regulations">
                                            <label for="regulations" class="contact__label">* Oświadczam, że zapoznałem/am się i akceptuję Regulamin świadczenia usług drogą elektroniczną przez Telewizę Polską S.A. w Portalu kraina-abc.tvp.pl oraz Politykę Prytwaności. Jestem świadom/a że więcej szczegółów w powyższym zakresie znajduje się we wskazanych wyżej dokumentach.</label>
                                            <div v-if="errors.regulations" class="errors">{{ errors.regulations }}</div>
                                        </div> -->

                                        <button @keyup="handleSubmit" type="submit" class="contact__submit">Wyślij</button>
                                    </div>
                                </div>                                
                            </form>

                            <span v-else class="opinions__confirm">Dziękujemy za przesłanie wiadomości</span>
                        </template>
                        <template v-else>
                            <div data-aos="fade-in">
                                <h4>Ankieta</h4>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccountSideMenu from "./AccountSideMenu.vue";

export default {
    name: "AccountOpinions",
    components: {
        AccountSideMenu,
    },
    data() {
        return {
            fields: {
                email: '',
                subject: '',
                message: '',
                // regulations: false,
                agreement: false,
            },
            errors: {
                email: '',
                subject: '',
                message: '',
                // regulations: '',
                agreement: ''
            },
            isExpanded: false,
            isForm: true,
            isSend: false
            // isNoProfile: false
        };
    },
    watch: {
        contactData() {
            if(this.contactData && this.contactData.form && this.contactData.form.error) {
                this.validation();
            }

            if(this.contactData && this.contactData.error === null && this.validation()) {
                this.isSend = true;
            }
        }
    },
    computed: {
        path() {
            return this.$route.path;
        },
        contactData() {
            return this.$store.getters.getContactData
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }
    },
    methods: {
        handleSubmit() {
            if(this.validation()) {
                this.$store.dispatch('sendContact', this.fields);   
            }
        },
        validation() {
            if(this.contactData && this.contactData.fields && this.contactData.fields.email) {
                this.errors.email = this.contactData.fields.email[0];

            } else if(this.fields.email) {
                const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

                if (!re.test(this.fields.email)) {
                    this.errors.email = 'Błędna wartość pola E-mail';
                } else {
                    this.errors.email = '';
                }
            } else {
                this.errors.email = 'Pole nie może być puste'
            }

            // if (this.contactData && this.contactData.fields && this.contactData.fields.regulations) {
            //     this.errors.regulations = this.contactData.fields.regulations[0];
            // } else if (this.fields.regulations) {
            //     this.errors.regulations = '';
            // } else {
            //     this.errors.regulations = 'Pole nie może być puste'
            // }

            if (this.contactData && this.contactData.fields && this.contactData.fields.agreement) {
                this.errors.agreement = this.contactData.fields.agreement[0];
            } else if (this.fields.agreement) {
                this.errors.agreement = '';
            } else {
                this.errors.agreement = 'Pole nie może być puste'
            }

            if (this.contactData && this.contactData.fields && this.contactData.fields.subject) {
                this.errors.subject = this.contactData.fields.subject[0];
            } else if(this.fields.subject) {
                this.errors.subject = '';
            } else {
                this.errors.subject = 'Pole nie może być puste'
            }

            if (this.contactData && this.contactData.fields && this.contactData.fields.message) {
                this.errors.message = this.contactData.fields.message[0];
            } else if (this.fields.message) {
                this.errors.message = '';
            } else {
                this.errors.message = 'Pole nie może być puste'
            }

            if(!this.errors.email && !this.errors.subject && !this.errors.message && !this.errors.agreement) {
                return true;
            } 

            return false;
        }
    },
    mounted() {
        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        ); 
    }
};
</script>